import React, { memo, useState, useEffect, useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import { useHistory, useLocation, useParams } from 'react-router'
import classNames from 'classnames'
import Grid from '@material-ui/core/Grid'
import { useTranslation } from 'react-i18next'

import styles from './styles'
import EmptySearchIcon from 'assets/images/empty-search.png'
import { Main } from './components'
import { StoreValue } from 'store'
import { TSearchProps, EAppStateActionTypes } from 'models'
import { Loading, Read } from 'components'
import { SearchResult, supabase } from '../../utils/supabase'

const useStyles = makeStyles(styles)

const SearchComponentView: React.FunctionComponent<TSearchProps> = props => {
	const {
		// storeSearchQuery,
		storeDispatch,
		storeSearchSection,
		storeSearchLoading,
		storeSearchDebounceQuery,
	} = props
	const { articleSlug, postId }: { articleSlug: string; postId: string } =
		useParams()
	const history = useHistory()
	const location = useLocation()
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	// const client = useApolloClient()
	const [searchResult, setSearchResult] = useState<SearchResult[] | null>(
		null,
	)
	const [existsData, setExistsData] = useState(false)
	const {
		searchSection,
	}: {
		searchSection:
			| 'all'
			| 'employers'
			| 'people'
			| 'articles'
			| 'teams'
			| 'jobs'
	} = useParams()

	const fetchSearchResult = useCallback(async () => {
		const { data } = (await supabase.rpc('search', {
			data: storeSearchDebounceQuery,
		})) as { data: SearchResult[]; error: any }
		// const { data: searchResult } = await client.query({
		// 	fetchPolicy: 'network-only', // 'cache-first', TODO: 'network-only' is temporary
		// 	query: SearchQuery,
		// 	variables: {
		// 		data: storeSearchDebounceQuery,
		// 	},
		// })
		setSearchResult(data)
		storeDispatch &&
			storeDispatch({
				type: EAppStateActionTypes.updateSearchLoading,
				loading: false,
			})
	}, [storeSearchDebounceQuery, storeDispatch])

	useEffect(() => {
		if (storeSearchDebounceQuery) fetchSearchResult()
		else setSearchResult(null)
	}, [fetchSearchResult, storeSearchDebounceQuery])

	useEffect(() => {
		return () => {
			storeDispatch &&
				storeDispatch({
					type: EAppStateActionTypes.updateSearchSection,
					section: '',
				})
		}
	}, [storeDispatch])

	useEffect(() => {
		if (
			storeSearchDebounceQuery &&
			storeSearchDebounceQuery.trim().length > 0
		) {
			let checkExistsData = false
			if (searchResult && searchResult.length > 0) {
				checkExistsData = true
				setExistsData(checkExistsData)
				// Object.keys(searchResult.node).forEach(function (key) {
				// 	if (
				// 		key !== '__typename' &&
				// 		searchResult &&
				// 		searchResult.node[key].length > 0
				// 	) {
				// 		checkExistsData = true
				// 		setExistsData(checkExistsData)
				// 	} else {
				// 		setExistsData(checkExistsData)
				// 	}
				// })
			}
			if (
				checkExistsData &&
				location.pathname === `/${i18n.language}/search` &&
				storeSearchSection === ''
			) {
				storeDispatch &&
					storeDispatch({
						type: EAppStateActionTypes.updateSearchSection,
						section: 'all',
					})
				history.push(`/${i18n.language}/search/all`)
			}
		}
	}, [
		history,
		i18n.language,
		location.pathname,
		searchResult,
		storeDispatch,
		storeSearchDebounceQuery,
		storeSearchSection,
	])

	return (
		<>
			{(articleSlug || postId) && <Read />}
			<Grid
				container
				justifyContent="center"
				className={classNames(classes.container)}
			>
				<Grid
					item
					xs={12}
					sm={8}
					md={6}
					lg={4}
					className={classNames(
						classes.content,
						classes.contentContainer,
						classes.minWidth,
					)}
				>
					{storeSearchDebounceQuery &&
					storeSearchDebounceQuery.length > 0 &&
					!storeSearchLoading &&
					!existsData ? (
						<div
							className={classes.newSearchText}
							style={{ paddingTop: '20%' }}
						>
							{t(
								`We couldn't find anything\nTry to refine your search term`,
							)}
							<img
								alt=""
								src={EmptySearchIcon}
								className={classes.emptySearchIcon}
							/>
						</div>
					) : storeSearchLoading ? (
						<Loading size={48} style={{ margin: '20px auto' }} />
					) : !storeSearchDebounceQuery &&
					  searchSection !== 'employers' &&
					  searchSection !== 'teams' ? (
						<div
							className={classes.newSearchText}
							style={{ paddingTop: '20%' }}
						>
							{t(`Search for Employers, Teams, Jobs or Articles`)}
						</div>
					) : (
						<Main search={searchResult} />
					)}
				</Grid>
			</Grid>
		</>
	)
}

const SearchComponent = () => (
	<StoreValue
		keys={[
			'search.section|storeSearchSection',
			'search.loading|storeSearchLoading',
			'search.debounceQuery|storeSearchDebounceQuery',
			'storeDispatch',
		]}
	>
		<SearchComponentView />
	</StoreValue>
)

export default memo(SearchComponent)
